$(function () {
    form_questionnaire_validation();
    form_contact_validation();
});

function form_questionnaire_validation() {
    // initialize questionnaire form by ID
    const formQuestionnaire = $('form[id="form_questionnaire"]')

    // validate each questionnaire
    formQuestionnaire.each(function (e) {
        
        $(this).validate({
            rules: {
                project_name: 'required',
                project_type: 'required',
                project_year: 'required',
                project_approval: 'required',
                project_team: 'required',
                project_deadline: 'required',
                project_target: 'required',
                project_keyword: 'required',
                project_needs: 'required',
                project_target_ages: 'required',
                project_description: {
                    required: true,
                    minlength: 10,
                },
            },
            messages: {
                project_name: {
                    required: 'Please enter the project name'
                },
                project_type: {
                    required: 'Please enter the project type'
                },
                project_year: {
                    required: 'Please enter the project year'
                },
                project_approval: {
                    required: 'Please enter who has final approval'
                },
                project_team: {
                    required: 'Please enter the team communication details'
                },
                project_deadline: {
                    required: 'Please specify the project deadline'
                },
                project_needs: {
                    required: 'Please choose the project needs'
                },
                project_target_ages: {
                    required: 'Please choose the project target age'
                },
                project_target: {
                    required: 'Please specify the project target'
                },
                project_keyword: {
                    required: 'Please enter project keywords'
                },
                project_description: {
                    required: 'Please provide a description',
                    minlength: 'Please enter at least 10 characters for the description'
                }
            },
            errorPlacement: function (error, element) {
                var elementName = element.attr("base_error")
                error.appendTo("#" + elementName);
            },
            success: function (label, element) {
                $(element).removeClass('valid').addClass('is-valid');
            },
            submitHandler: function (form) {
                var submitButton = $(form).find('.btn-submit');
                $.ajax({
                    url: form.action,
                    type: form.method,
                    data: $(form).serialize(),
                    beforeSend: function () {
                        submitButton.html('Please wait...')
                        submitButton.prop('disabled', true)
                    },
                    success: function (data) {
                        if (data.status === 'success') {
                            submitButton.addClass('bg-dark')
                            submitButton.html('<span class="text slide-down">Sent... <span class="pe-7s-check close-icon fw-bold"></span></span>')
                            submitButton.prop('disabled', true)

                            setTimeout(() => {
                                submitButton.removeClass('bg-dark')
                                submitButton.html('<span class="text slide-down">Send Inquiry</span>')
                                submitButton.prop('disabled', false)

                                // Reset the form
                                form.reset();

                                $(form).find('.valid').removeClass('valid');
                                $(form).find('.is-valid').removeClass('is-valid');

                                $('.alert-message-box').html(alertButton('alert-success', data.status, data.message))
                            }, 2000)

                        } else {
                            $('.alert-message-box').html(alertButton('alert-danger', data.status, data.message))
                        }
                    },
                    error: function (xhr) {
                        $('.alert-message-box').html('<div class="alert alert-danger">' + xhr.responseJSON.message + '</div>')
                    }
                });
                return false;
            },
        });
    });
}

function form_contact_validation() {
    // initialize contact form by ID
    const formContact = $('form[id="form_contact"]')

    // validate each contact
    formContact.each(function (e) {
        
        $(this).validate({
            rules: {
                first_name: 'required',
                email: 'required',
                inquiry: {
                    required: true,
                    minlength: 10,
                }
            },
            messages: {
                first_name: {
                    required: 'Please enter the first name'
                },
                email: {
                    required: 'Please enter the email'
                },
                inquiry: {
                    required: 'Please enter the inquiry',
                    minlength: 'Please enter at least 10 characters for the inquiry'
                },
            },
            errorPlacement: function (error, element) {
                var elementName = element.attr("base_error")
                error.appendTo("#" + elementName);
            },
            success: function (label, element) {
                $(element).removeClass('valid').addClass('is-valid');
            },
            submitHandler: function (form) {
                var submitButton = $(form).find('.btn-submit');
                $.ajax({
                    url: form.action,
                    type: form.method,
                    data: $(form).serialize(),
                    beforeSend: function () {
                        submitButton.html('Please wait...')
                        submitButton.prop('disabled', true)
                    },
                    success: function (data) {
                        if (data.status === 'success') {
                            submitButton.addClass('bg-dark')
                            submitButton.html('<span class="text slide-down">Sent... <span class="pe-7s-check close-icon fw-bold"></span></span>')
                            submitButton.prop('disabled', true)

                            setTimeout(() => {
                                submitButton.removeClass('bg-dark')
                                submitButton.html('<span class="text slide-down">Send Inquiry</span>')
                                submitButton.prop('disabled', false)

                                // Reset the form
                                form.reset();

                                $(form).find('.valid').removeClass('valid');
                                $(form).find('.is-valid').removeClass('is-valid');


                                $('.alert-message-box').html(alertButton('alert-success', data.status, data.message))
                            }, 2000)

                        } else {
                            $('.alert-message-box').html(alertButton('alert-danger', data.status, data.message))
                        }
                    },
                    error: function (xhr) {
                        $('.alert-message-box').html('<div class="alert alert-danger">' + xhr.responseJSON.message + '</div>')
                    }
                });
                return false;
            },
        });
    });
}

function alertButton(className, status, message) {
    let button = '';
    button += '<div class="alert ' + className + '  alert-dismissible fade show" role="alert">'+
        '<strong class="text-capitalize">' + status + '!</strong> ' + message + '.'+
        '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>'+
        '</div>';
    return button;
}